<script setup>
clearError({
  redirect: '/404',
})
</script>
